import { render } from "./Title.vue?vue&type=template&id=c02207ca&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=c02207ca&lang=scss&scoped=true"

import exportComponent from "/opt/web_acelerometrica_publica/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c02207ca"]])

export default __exports__